import { moduleFactory } from "@/factories/module";
import { triggerToast } from "@/modules/toast/trigger";

export const toastModule = moduleFactory.create({
  triggerToast,
});
